import { Component, ViewChild, ElementRef } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { NodeService } from '../../Services/api-nodeservice';
import { Api } from '../../Model/api-model';
import { Router, ActivatedRoute } from '@angular/router';
import fhir from '../../../assets/Data/Fhir.json';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { FhirApiListDevPortal, FhirApiDevPortal} from 'src/app/Model/fhirapilist-model'
//import FilePath from '../../../config/AccessAPI';
@Component({
  selector: 'app-fhirapi',
  templateUrl: './fhirapis.component.html'
})
export class FHIRApisComponent{
 // fhirList:{id:string,API:string,Description:string}[]=fhir;
  constructor(  private route: ActivatedRoute,public router: Router,private http: HttpClient) {
    localStorage.setItem("is_cuurent_nav_aem","y");
  }

  @ViewChild('details') myDiv: ElementRef;

 //fhirapiList:string[];
 cols: any[];
 fhirapiList:FhirApiDevPortal[];
 newArray: any[];
 copy : string;

 copyToClipboard(data,env){
   //console.log(data);
   this.copy = data.substring(0, data.indexOf(' '));

   if(env=='Production'){
    this.copy='https://apif1.aetna.com/fhir'+this.copy;
   }else{
    this.copy='https://vteapif1.aetna.com/fhirdemo'+this.copy;
   }

   //console.log(this.copy);
   navigator.clipboard.writeText(this.copy);
 }
  displayApiLibHead;
  ngOnInit() {
    window.scrollTo(0, 0);
    this.displayApiLibHead= localStorage.getItem("api_display_text");
    this.cols = [
      { field: 'API',header: 'API Name'}, 
      { field: 'id', header: 'API ID' },
      { field: 'Environment', header: 'Environment' }];

    console.log("ng on init")
    let F1 = localStorage.getItem("PublicViewAccess");

    let F2 = localStorage.getItem("PublicViewAccess2");

    this.getFhirAPIsfromAEM().subscribe(data => {
     this.fhirapiList = data as FhirApiDevPortal[]
      //console.log(this.fhirapiList);

      var PF1 = [];

      console.log("f2 "+F2)
      for (const i in this.fhirapiList) {
        console.log("api "+this.fhirapiList[i].SwagerFile)
        
        if (this.fhirapiList[i].API.includes(F1) || this.fhirapiList[i].API.includes(F2)
         || ((F1=='patientaccess') &&(this.fhirapiList[i].SwagerFile.includes("_v1_realtimepharmacybenefitcheck_process-message")))
        || ((F1=='patientaccess') &&(this.fhirapiList[i].SwagerFile.includes("_v1_sandbox_realtimepharmacybenefitcheck_process-message"))) 
        || ((F1=='provideraccess') &&(this.fhirapiList[i].SwagerFile.includes("interop_sandbox_realtimepharmacybenefitcheck_v1_process_message.yaml"))) 
         || ((F1=='provideraccess') &&(this.fhirapiList[i].SwagerFile.includes("interop_realtimepharmacybenefitcheck_v1_process_message.yaml")))
         || ((F1=='provideraccess') &&(this.fhirapiList[i].SwagerFile.includes("priorauthorizationsupport_v1_claim_sandbox.yaml")))){  
          console.log("matches "+F2)

            PF1.push(this.fhirapiList[i]);
  
          }
          
        }
        this.fhirapiList= PF1;

      const sortArrayObjs = function(arr, prop1, prop2) {
        let sort1 = [...arr].sort((a, b) => {
          if (a[prop1] == b[prop1]) {
            if (a[prop2] === b[prop2]) return 0;
            return (a[prop2] < b[prop2]) ? -1 : 1;
          } else {
            return (a[prop1] < b[prop1]) ? -1 : 1;
          }
        });
        return sort1;
      };

      this.newArray = sortArrayObjs(this.fhirapiList, 'Environment', 'API');
      //console.log(this.newArray);
      return this.newArray;
     },
     (err: HttpErrorResponse) => {
       console.log(err.message);
     }
     );
  }

  public getFhirAPIsfromAEM(): Observable<any> {
   console.log("logging AEM call entry")
 
   if(environment.getAemurl()=='none'){
    return this.http.get('/assets/Data/Fhir.json');
   }else{
     return this.http.get(environment.getAemurl()+'/json/Fhir.json');
   }

 

  
  }


  movetoStaticSwagger(fileName){
    //console.log("fileName "+fileName)	     //  this.router.navigate(['fhir/apis/swagger']);
    this.router.navigate(['fhir/apis/swagger/'+fileName]);
     
   }

   ngAfterViewInit() {
    // Hack: Scrolls to top of Page after page view initialized
    
    //let top = document.getElementById('top');
    //if (top !== null) {
     // top.scrollIntoView();
     // top = null;
   // }
    
  }

}

